import Body from "./table-body/body";
import Header from "./table-header/header";
import table from "./table-root/table";

export const Table = {
  Root: table,
  Header: Header,
  Body: Body
}